import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../App.css";
import Modal from "react-bootstrap/Modal";
import Header from "./header";
import SideNav from "./sidenav";
import { toast } from "react-toastify";
import Dashboard3 from "../assets/images/dashboard-3.png";
import Accordion from "react-bootstrap/Accordion";
import { changePassword } from "../redux/actions/authAction";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  changePaymentStatus,
  getStore,
  getStoreUpload,
} from "../redux/actions/storeAction";
const initialState = {
  newPassword: "",
  oldPassword: "",
  compareNewPassword: "",
  errors: {},
};

const Settings = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [iState, updateState] = useState(initialState);
  const { oldPassword, newPassword, compareNewPassword, errors } = iState;
  const handleChange = (e) => {
    const { name, value } = e.target;
    updateState({
      ...iState,
      [name]: value,
    });
  };

  const handleValidation = () => {
    let error = {};
    let formIsValid = true;

    if (!oldPassword.trim()) {
      error.oldPasswordEmpty = "* Old Password can't be empty";
      formIsValid = false;
    }
    if (!newPassword.trim()) {
      error.newPasswordEmpty = "* New Password can't be empty";
      formIsValid = false;
    }
    if (!compareNewPassword.trim()) {
      error.compareEmpty = " * Confirm Password can't be empty";
      formIsValid = false;
    }

    if (
      compareNewPassword &&
      newPassword &&
      compareNewPassword !== newPassword
    ) {
      error.compareEmpty = " * Confirm password must be same as new password";
      formIsValid = false;
    }
    if (oldPassword && newPassword && oldPassword === newPassword) {
      error.newPasswordEmpty = " * New Password will not same as old password";
      formIsValid = false;
    }
    // if (newPassword) {
    //   let valid = checkPassword(newPassword);
    //   if (!valid) {
    //     error.newPasswordEmpty =
    //       "Your password must contain at least one uppercase, lowercase, number, special character and length must be 8.";
    //     formIsValid = false;
    //   }
    // }

    updateState({
      ...iState,
      errors: error,
    });
    return formIsValid;
  };

  const handleChangePassword = () => {
    let formIsValid = handleValidation();
    if (formIsValid) {
      let data = { oldPassword, newPassword };
      dispatch(changePassword(data)).then((res) => {
        if (res.status === 200) {
          toast.success(res.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          updateState(initialState);
          navigate("/dashboard");
        } else {
          toast.error(res.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      });
    }
  };

  const [cashPayment, setCashPayment] = useState(false);
  const [autoId, setAutoId] = useState(null);
  useEffect(() => {
    dispatch(getStore({})).then((res) => {
      if (res.status === 200) {
        setCashPayment(res.data.cashPayment);
        setAutoId(res.data._id);
      }
    });
  }, []);

  const handleToggle = async () => {
    const newValue = !cashPayment;
    setCashPayment(newValue);
    try {
      const payload = { cashPayment: newValue, _id: autoId };
      const res = await dispatch(getStoreUpload(payload));
      if (res.status === 200) {
        toast.success(res.message);
        const storeRes = await dispatch(getStore({}));
        if (storeRes?.status === 200 && storeRes?.data) {
          const { cashPayment, _id } = storeRes.data;
          setCashPayment(cashPayment);
          setAutoId(_id);
        }
      } else {
        toast.error(res.message);
        setCashPayment(!newValue);
      }
    } catch (err) {
      toast.error("Something went wrong");
      setCashPayment(!newValue);
    }
  };

  return (
    <div>
      <Header />
      <SideNav />

      <div class="WrapperArea">
        <div class="WrapperBox">
          <div class="TitleBox">
            <div>
              <h4>Settings</h4>
            </div>
          </div>
          <div className="StaticBoxArea">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <h3>
                    <span>
                      <i className="fa fa-unlock-alt" aria-hidden="true"></i>
                    </span>
                    Change Password
                  </h3>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="CommonForms">
                    <div className="form-group">
                      <div className="row">
                        <div className="col-sm-3">
                          <label>Enter your old Password</label>
                        </div>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your old Password"
                            name="oldPassword"
                            value={oldPassword}
                            onChange={handleChange}
                          />
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {errors.oldPasswordEmpty}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <div className="row">
                        <div className="col-sm-3">
                          <label>Create New Password</label>
                        </div>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Create New Password"
                            name="newPassword"
                            value={newPassword}
                            onChange={handleChange}
                          />
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {errors.newPasswordEmpty}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <div className="row">
                        <div className="col-sm-3">
                          <label>Confirm your password</label>
                        </div>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Confirm your password"
                            name="compareNewPassword"
                            value={compareNewPassword}
                            onChange={handleChange}
                          />
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {errors.compareEmpty}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="ButtonMain" onClick={handleChangePassword}>
                      <button className="Button AddButton">
                        Update Password
                      </button>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <h3>
                    <img src={Dashboard3} />
                    Change Payment Status
                  </h3>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="CommonForms">
                    <div className="form-group">
                      <div>
                        <h6>Cash </h6>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={cashPayment}
                            onChange={handleToggle}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Settings;
